import script from "./section-4.vue?vue&type=script&lang=ts&setup=true"
export * from "./section-4.vue?vue&type=script&lang=ts&setup=true"

import "./section-4.vue?vue&type=style&index=0&id=2180a04b&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2180a04b"]])

export default __exports__